module.exports = __webpack_public_path__ + "static/media/green-checkmark.35b2cfbf.svg";